export default __webpack_public_path__ + "img/7cb886a42558bc5fffc8e86769de6954.svg";